'use client';

import { type ButtonProps } from '@ironhack/design-system2/components/button';
import { Flex, type FlexProps } from '@ironhack/design-system2/components/flex';
import { Text } from '@ironhack/design-system2/components/text';
import { Mail } from '@ironhack/design-system2/icons/mail';
import { type ReactElement, useEffect } from 'react';

import { Button } from '@/app/components/client/button';
import { ConfettiBox } from '@/app/components/client/confetti-box';
import { type DatoButtonBlock } from '@/lib/datocms';

type Props = {
  button: [DatoButtonBlock];
  buttonProps?: ButtonProps;
  text: string;
  title: string;
} & FlexProps;

export const FormThankYou = (props: Props): ReactElement => {
  const {
    button: [button],
    buttonProps = {},
    text,
    title,
    ...flexProps
  } = props;

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  return (
    <Flex alignItems="center" direction="column" w="full" {...flexProps}>
      <Text textStyle="2xl">{title}</Text>
      <ConfettiBox h="104px" icon={Mail} mt={1} />
      <Text mt={3} textStyle="l">
        {text}
      </Text>
      <Button {...button} mt={3} {...buttonProps} />
    </Flex>
  );
};
